<template>
  <div class="max-w-6xl mx-auto">
    <BreadCrumb :property="property" />
    <PropertyImages :property="property" />

    <PropertyDescription :property="property" />
  </div>
  <SimilarProperties :property="property" />
</template>
<script>
import axios from "axios";
import { ref, onMounted } from "vue";
import BreadCrumb from "@/features/new-projects/project/BreadCrumb.vue";
import PropertyImages from "@/features/new-projects/project/ImageView.vue";
import PropertyDescription from "@/features/new-projects/project//DescriptionView.vue";
import SimilarProperties from "@/features/new-projects/project/SimilarPropertiesView.vue";
// import PropertySidebar from "@/features/property/PropertySidebar.vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
export default {
  components: {
    BreadCrumb,
    PropertyImages,
    PropertyDescription,
    SimilarProperties,
    // PropertySidebar,
  },
  setup() {
    const route = useRoute();
    const store = useStore();
    const base_url = store.state.baseUrl;
    const property = ref(null);

    onMounted(() => {
      axios
        .get(`${base_url}new-projects/${route.params.id}`)
        .then((response) => {
          property.value = response.data.data;
        })
        .catch((error) => console.log(error));
    });

    return {
      base_url,
      property,
    };
  },
};
</script>
